import { Link } from 'react-router';

// Call to Action Component
export default function CallToAction() {
  return (
    <section className='py-20 bg-gradient-to-r from-green-600 via-emerald-600 to-teal-600 relative overflow-hidden'>
      <div className='absolute inset-0'>
        {/* Enhanced floating elements */}
        <div className='absolute top-10 right-20 w-32 h-32 bg-gradient-to-br from-yellow-300/20 to-white/10 rounded-full animate-pulse'></div>
        <div className='absolute bottom-20 left-10 w-24 h-24 bg-gradient-to-tl from-white/15 to-yellow-200/10 rounded-full animate-pulse animation-delay-200'></div>
        <div className='absolute top-1/3 left-1/2 w-20 h-20 bg-gradient-to-r from-white/5 to-yellow-300/15 rounded-full animate-pulse animation-delay-400'></div>
        
        {/* Particle effects */}
        <div className='absolute top-1/4 right-1/3 w-3 h-3 bg-yellow-300/40 rounded-full animate-bounce'></div>
        <div className='absolute bottom-1/3 left-1/4 w-2 h-2 bg-white/50 rounded-full animate-bounce animation-delay-500'></div>
        <div className='absolute top-2/3 right-1/4 w-4 h-4 bg-yellow-200/30 rounded-full animate-bounce animation-delay-700'></div>
        
        {/* Hexagonal pattern */}
        <div className='absolute inset-0'>
          <svg className='w-full h-full opacity-5' viewBox='0 0 60 60'>
            <defs>
              <pattern id='hexPattern' x='0' y='0' width='20' height='20' patternUnits='userSpaceOnUse'>
                <polygon points='10,2 18,7 18,13 10,18 2,13 2,7' fill='none' stroke='currentColor' strokeWidth='0.5' className='text-white'/>
              </pattern>
            </defs>
            <rect width='100%' height='100%' fill='url(#hexPattern)'/>
          </svg>
        </div>
        
        {/* Radial gradient overlay */}
        <div className='absolute inset-0 bg-gradient-radial from-transparent via-green-500/5 to-emerald-700/10'></div>
      </div>
      
      <div className='container mx-auto px-6 text-center relative z-10'>
        <div className='max-w-4xl mx-auto'>
          <h2 className='text-4xl md:text-5xl font-bold text-white mb-6 font-comfortaa'>
            Ready to Transform Your <span className='text-yellow-300'>Future?</span>
          </h2>
          <p className='text-xl text-green-100 mb-10 leading-relaxed'>
            Join us in creating solutions that make a real difference. Let's build something extraordinary together.
          </p>
          
          <div className='flex flex-col sm:flex-row gap-4 justify-center'>
            <Link
              to='/services'
              className='bg-white text-green-600 hover:bg-yellow-300 hover:text-green-800 px-8 py-4 rounded-full text-lg font-bold transition-all duration-300 transform hover:scale-105 shadow-xl inline-flex items-center justify-center gap-2'
            >
              Explore Our Services
              <svg className='w-5 h-5' fill='none' stroke='currentColor' viewBox='0 0 24 24'>
                <path strokeLinecap='round' strokeLinejoin='round' strokeWidth={2} d='M17 8l4 4m0 0l-4 4m4-4H3' />
              </svg>
            </Link>
            
            <Link
              to='/contact'
              className='border-2 border-white text-white hover:bg-white hover:text-green-600 px-8 py-4 rounded-full text-lg font-bold transition-all duration-300 transform hover:scale-105 inline-flex items-center justify-center gap-2'
            >
              Get In Touch
              <svg className='w-5 h-5' fill='none' stroke='currentColor' viewBox='0 0 24 24'>
                <path strokeLinecap='round' strokeLinejoin='round' strokeWidth={2} d='M8 12h.01M12 12h.01M16 12h.01M21 12c0 4.418-4.03 8-9 8a9.863 9.863 0 01-4.255-.949L3 20l1.395-3.72C3.512 15.042 3 13.574 3 12c0-4.418 4.03-8 9-8s9 3.582 9 8z' />
              </svg>
            </Link>
          </div>
        </div>
      </div>
    </section>
  )
}